module.exports = __webpack_public_path__ + "static/preview-vivaan-c7fdbfbbf7ff2a3702897ed2efb424c9.wav";